import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import style from './ProgressBar.module.scss.js';
import cx from 'classnames';
import PropTypes from 'prop-types';

var _excluded = ["barColor", "percentage", "showStrength", "className"];
var defaultCollection = [{
  key: 'empty',
  minPercentage: 0,
  maxPercentage: 0,
  message: 'Password Strength'
}, {
  key: 'dangerous',
  minPercentage: 1,
  maxPercentage: 19,
  message: 'Dangerous',
  color: '#FF4440'
}, {
  key: 'weak',
  minPercentage: 20,
  maxPercentage: 39,
  message: 'Weak',
  messageDescription: 'Straight rows of keys are easy to guess.',
  color: '#FCAF2F'
}, {
  key: 'average',
  minPercentage: 40,
  maxPercentage: 59,
  message: 'Average',
  color: '#7A34FF'
}, {
  key: 'strong',
  minPercentage: 60,
  maxPercentage: 79,
  message: 'Strong',
  color: '#28BF6F'
}, {
  key: 'strongest',
  minPercentage: 80,
  maxPercentage: 100,
  message: 'Strongest',
  color: '#209858'
}];
var findCurrentState = function findCurrentState(collection, percentage) {
  var values = collection;
  var state = values.findIndex(function (_ref) {
    var minPercentage = _ref.minPercentage,
      maxPercentage = _ref.maxPercentage;
    return minPercentage > percentage && percentage < maxPercentage;
  });
  state = state === -1 ? values.length - 1 : state - 1;
  return collection[state];
};
var ProgressBar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ProgressBar, _Component);
  function ProgressBar(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      currentState: findCurrentState(props.collection, props.percentage)
    };
    return _this;
  }
  var _proto = ProgressBar.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props = this.props,
      percentage = _this$props.percentage,
      collection = _this$props.collection,
      showStrength = _this$props.showStrength;
    if (prevProps.percentage !== percentage) {
      if (showStrength) {
        var state = findCurrentState(collection, percentage);
        this.setState({
          currentState: state
        });
      }
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      barColor = _this$props2.barColor,
      percentage = _this$props2.percentage,
      showStrength = _this$props2.showStrength,
      className = _this$props2.className,
      args = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    var currentState = this.state.currentState;
    return /*#__PURE__*/React.createElement("div", _extends({
      className: cx(className)
    }, args), /*#__PURE__*/React.createElement("div", {
      className: cx(style.progressBarContainer),
      style: {
        backgroundColor: barColor
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(style.progressBar),
      style: {
        width: (percentage > 100 ? 100 : percentage) + "%",
        backgroundColor: currentState.color
      }
    })), showStrength && /*#__PURE__*/React.createElement("div", {
      className: cx(style.progressStatus)
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: currentState.color
      }
    }, currentState.message), /*#__PURE__*/React.createElement("span", {
      className: cx(style.progressTip)
    }, currentState.messageDescription)));
  };
  return ProgressBar;
}(Component);
ProgressBar.defaultProps = {
  collection: defaultCollection,
  percentage: 0,
  showStrength: true
};
ProgressBar.propTypes = {
  /**
   * An array specifying the min/max values for a given range, the key value, and the
   * color to display for the range
   * and an optional message (and description) to show if the percentage falls within the range
   * The array should capture all possible values from 0-100
   [{
      key: 'empty',
      minPercentage: 0,
      maxPercentage: 0,
      message: 'No password',
  },
   {
      key: 'dangerous',
      minPercentage: 1,
      maxPercentage: 19,
      message: 'Dangerous',
      messageDescription: 'Straight rows of keys are easy to guess.',
      color: '#FF4440',
      }, ...]
    */
  collection: PropTypes.array,
  /**
   * The percentage the display bar should show
   */
  percentage: PropTypes.number,
  /**
   * The collection strenght the display bar should show
   */
  showStrength: PropTypes.bool
};

export { ProgressBar as default };
//# sourceMappingURL=index.js.map
